var render, staticRenderFns
import script from "./StaffChart.vue?vue&type=script&lang=js"
export * from "./StaffChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('731c2c5d')) {
      api.createRecord('731c2c5d', component.options)
    } else {
      api.reload('731c2c5d', component.options)
    }
    
  }
}
component.options.__file = "src/view/pages/components/Statistics/StaffChart.vue"
export default component.exports